import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import CompressFilesImagesListScreen from "./CompressFilesImagesListScreen";
import { BASE_URL } from "../Config";

function CompressFilesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Compress Files, Zip Files For Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/compress_files", title: "Create Zip Files For Free" },
    data2: { link: "/compress_files", title: "Reduce File Size (.zip)" },
    data3: { link: "/compress_files", title: "File Compressor" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Compress and zip files online instantly. Reduce file size, save storage, and share documents quickly with our fast, secure file compression tool."
      ></meta>
      <meta
        name="keywords"
        content="file compressor, zip files online, compress files online, reduce file size, online file compressor, file zip tool, compress documents, file shrink tool, document compressor, online file zip, compress large files, file compression tool, zip and compress files, file optimizer, compress files for email"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CompressFilesImagesListScreen
          title={title}
        ></CompressFilesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView selectMultiple={true} allowFolder={true} />
          {/* Mid Section */}
          <MiscPageMidSection description="Our File Compressor website provides a fast, secure, and efficient solution to reduce file sizes without compromising quality, even when there is no internet connection. Built to work fully offline, this powerful tool allows users to compress files directly on their device, ensuring complete privacy and data protection. Whether you need to shrink documents, images, videos, or folders, this offline-ready solution supports multiple formats and delivers optimized compression results. The platform also offers flexible online access, enabling users to use it as a file compressor online or a fully offline utility based on their needs. With intuitive controls, users can quickly zip files, compress files, and bundle multiple items into a single archive. Acting as a reliable online file compressor with offline capabilities, the tool makes it easy to create zip file online or offline for fast sharing, uploading, and storage. Optimized for speed and performance, it reduces file sizes efficiently while maintaining original content quality. Ideal for students, professionals, and businesses, this website is perfect for email attachments, cloud uploads, backups, and file management. If you are looking for a dependable file compressor online, a secure way to compress files, zip files, or create zip file online with offline support, this platform delivers a smooth experience designed for modern file handling needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Compress",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="File Compressor"
            why_use={[
              {
                title: "Reduce File Size for Easy Sharing",
                description:
                  "Our file compressor reduces large file sizes, making it easier to share files via email, messaging apps, or cloud platforms.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Using compress files tools helps free up disk space by shrinking files without affecting usability.",
              },
              {
                title: "Faster Uploads and Downloads",
                description:
                  "Smaller compressed files upload and download faster. Our file compressor online improves transfer speed.",
              },
              {
                title: "Create ZIP Files Easily",
                description:
                  "This file compressor allows users to zip files and combine multiple files into a single archive.",
              },
              {
                title: "Simplify File Organization",
                description:
                  "Creating ZIP archives helps organize files. Tools that create zip file online make file management easier.",
              },
              {
                title: "Offline Compression for Privacy",
                description:
                  "Our offline file compressor processes files locally, ensuring sensitive data remains private and secure.",
              },
              {
                title: "Reduce Bandwidth Usage",
                description:
                  "Using a file compressor online or offline reduces bandwidth consumption during file transfers.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals rely on compress files tools for assignments, reports, and project submissions.",
              },
              {
                title: "Maintain File Quality and Integrity",
                description:
                  "Modern file compressor online tools compress files while preserving original data quality and structure.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CompressFilesMain;
